import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.vorlagen-config-types';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenVorlagenConfigTypesEffects {

    VorlagenConfigTypes$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VORLAGEN_CONFIG_TYPES),
        mergeMap((x: ac.GetVorlagenConfigTypesAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVorlagenConfigTypes().pipe(
                map((result: any) => {
                    return new ac.GetVorlagenConfigTypesErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVorlagenConfigTypesFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenTemplatesService);
        }
        return this.service;
    }
}
